export default [
  {
    path: "/learning",
    name: "learning",
    component: () => import("@/views/learning/learning.vue"),
    meta: {
      title: "学习",
    },
  },
  {
    path: "/learning/learningList",
    name: "/learning/learningList",
    component: () =>
      import("@/views/learning/views/learningList/learningList.vue"),
    meta: {
      title: "学习课程",
    },
  },
  {
    path: "/learningDetails",
    name: "/learningDetails",
    component: () =>
      import("@/views/learning/views/learningList/learningDetails.vue"),
    meta: {
      title: "课程详情",
    },
  },
];
